import {getCookie} from './helpers';

window.currency = {
    setup() {
        //
        // Trigger Currency
        //
        this.triggerCurrencyElements();
    },

    triggerCurrencyElements() {
        let shouldWeRun = (
            document.querySelectorAll('[data-currency-monthly]').length > 0 ||
            document.querySelectorAll('[data-currency-yearly]').length > 0 ||
            document.querySelectorAll('[data-dynamic-prices]').length > 0
        );

        if (!shouldWeRun) {
            return;
        }

        new Promise((resolve) => {
            let currency = getCookie('currency');

            if (currency == null) {
                $.ajax({
                    url: window.loginEndpoint + '/checkout/currency',
                    type: 'GET',
                    success: function (response) {
                        document.cookie = 'currency=' + response + '; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
                        resolve(response);
                    },
                    error: function (result) {
                        console.log('[triggerCurrencyElements] error', result);
                    },
                });
            } else {
                resolve(currency);
            }
        })
            .then(function (currency) {
                console.log('currency', currency);
                let currencies = [
                    'gbp',
                    'eur',
                    'usd',
                    'cad',
                    'aud',
                    'nzd',
                ];

                //
                // Default to GBP
                //
                if (!currencies.includes(currency)) {
                    console.log('default to ', currency);
                    currency = 'gbp';
                }

                //
                // Monthly Per Day {monthly_per_day}
                //
                let monthlyPerDay =
                    window.prices[currency]['symbol'] +
                    window.prices[currency]['monthly_per_day'] +
                    (window.prices[currency]['suffix'] ? ' ' + window.prices[currency]['suffix'] : '');

                //
                // Monthly Per Month {monthly_per_month}
                //
                let monthlyPerMonth =
                    window.prices[currency]['symbol'] +
                    window.prices[currency]['monthly_per_month'] +
                    (window.prices[currency]['suffix'] ? ' ' + window.prices[currency]['suffix'] : '');

                //
                // Yearly Per Day {yearly_per_day}
                //
                let yearlyPerDay =
                    window.prices[currency]['symbol'] +
                    window.prices[currency]['yearly_per_day'] +
                    (window.prices[currency]['suffix'] ? ' ' + window.prices[currency]['suffix'] : '');

                //
                // Yearly Per Month {yearly_per_month}
                //
                let yearlyPerMonth =
                    window.prices[currency]['symbol'] +
                    window.prices[currency]['yearly_per_month'] +
                    (window.prices[currency]['suffix'] ? ' ' + window.prices[currency]['suffix'] : '');

                //
                // Yearly Per Year {yearly_per_year}
                //
                let yearlyPerYear =
                    window.prices[currency]['symbol'] +
                    window.prices[currency]['yearly_per_year'] +
                    (window.prices[currency]['suffix'] ? ' ' + window.prices[currency]['suffix'] : '');

                console.log(
                    monthlyPerDay,
                    monthlyPerMonth,
                    yearlyPerDay,
                    yearlyPerMonth,
                    yearlyPerYear
                );

                // @deprecated
                // Inject "£7.99" into the element's html
                document.querySelectorAll('[data-currency-monthly]').forEach((elm) => {
                    elm.innerText = monthlyPerMonth;
                });

                // @deprecated
                // Inject "£59.99" into the element's html
                document.querySelectorAll('[data-currency-yearly]').forEach((elm) => {
                    elm.innerText = yearlyPerYear;
                });

                // Swap dynamically
                document.querySelectorAll('[data-dynamic-prices]').forEach((elm) => {
                    let text = elm.innerText;
                    text = text.replace('{monthly_per_day}',    monthlyPerDay);
                    text = text.replace('{monthly_per_month}',  monthlyPerMonth);
                    text = text.replace('{yearly_per_day}',     yearlyPerDay);
                    text = text.replace('{yearly_per_month}',   yearlyPerMonth);
                    text = text.replace('{yearly_per_year}',    yearlyPerYear);
                    elm.innerText = text;
                });
            })
            .catch(function (error) {
                console.log('[triggerCurrencyElements] error', error);
            });
    },
}
